export default [
  { value: 1, text: 'offen', textVerbose: 'Offene Gesuche', active: true },
  { value: 2, text: 'bewilligt', textVerbose: 'Bewilligte Gesuche', active: false },
  { value: 3, text: 'realisiert', textVerbose: 'Realisierte Gesuche', active: false },
  { value: 4, text: 'sistiert', textVerbose: 'Sistierte Gesuche', active: false }
]
